import React, { useEffect, useRef, useState } from "react";
import qrCode from "./qrCode.png";
import defaultImage from "./productDefaultImage.png";

export function SideAppDownloadBanner() {
    const [open, setOpen] = useState(false);
    const bannerRef = useRef(null); // ✅ Reference to the whole banner

    const heightCls = "h-60 md:h-64";

    // ✅ Close banner when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (bannerRef.current && !bannerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    return (
        <aside
            ref={bannerRef} // ✅ Attach ref here
            className={`hidden md:block fixed right-0 top-1/2 -translate-y-1/2 z-50 select-none `}
            aria-label="App download offer"
        >
            <div className="relative flex items-stretch">
                {/* Vertical Tab */}
                <button
                    aria-label={open ? "Collapse offer" : "Expand offer"}
                    aria-expanded={open}
                    onClick={() => setOpen((v) => !v)}
                    className={`group focus:outline-none overflow-hidden shadow bg-red-600 text-white w-9 ${heightCls}`}
                    style={{ writingMode: "vertical-lr" }}
                >
                    <div className="relative flex h-full w-full items-center justify-center">
                        <span className="ps-4 text-xs md:text-sm font-bold tracking-wide text-center">
                            15% OFF + ₹1000 INARI CASH
                        </span>

                        {/* Arrow: change rotation depending on open state */}
                        {/* Decorative triangle icon (same shape/feel as shown) */}
                        <svg className="absolute left-2 top-3 h-5 w-5" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                            {open ? <polygon points="3,2 10,6 3,10" fill="currentColor" /> : <polygon points="9,2 2,6 9,10" fill="currentColor" />}
                            {/* <polygon points="3,2 10,6 3,10" fill="currentColor" /> */}
                        </svg>
                    </div>
                </button>

                {/* Expanded panel */}
                {open && (
                    <div
                        role="dialog"
                        aria-label="App download details"
                        className={`w-70 md:w-86 border bg-white text-black shadow-lg overflow-hidden ${heightCls}`}
                    >
                        <div className="h-full p-2 md:p-4 grid grid-rows-[auto_auto_1fr]">
                            <div>
                                <p className="text-sm md:text-base">Log in on App and</p>
                                <h3 className="text-xl md:text-2xl font-semibold mt-1 text-gray-900">Get ₹1000 Inari Cash</h3>
                                <p className="text-sm md:text-base mt-1">& 15% off on first order (APP15)</p>
                                <p className="text-xs text-gray-400">Applicable on your first App purchase</p>
                            </div>

                            <div className="mt-2 md:mt-3 grid grid-cols-[auto,1fr] gap-2 items-center">
                                <img
                                    src={qrCode || defaultImage}
                                    alt="Scan to download the app"
                                    className="h-24 w-24 md:h-28 md:w-28 border bg-white"
                                />
                                <div className="flex flex-col gap-2">
                                    {/* App Store Button */}
                                    <a
                                        href="#"
                                        className="inline-flex items-center border bg-white text-black px-1 py-1.5 hover:bg-gray-800 hover:text-white transition-colors"
                                        style={{ borderRadius: '0' }}
                                    >
                                        <svg className="w-8 h-8 mr-2" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                                        </svg>
                                        <div className="text-left">
                                            <div className="text-xs">Download on the</div>
                                            <div className="text-sm font-semibold">App Store</div>
                                        </div>
                                    </a>

                                    {/* Google Play Button */}
                                    <a
                                        href="#"
                                        className="inline-flex items-center border bordr-black bg-white text-black px-1 py-1.5 hover:bg-gray-800 hover:text-white transition-colors"
                                        style={{ borderRadius: '0' }}
                                    >
                                        <svg className="w-8 h-8 mr-2" viewBox="0 0 24 24">
                                            <defs>
                                                <linearGradient id="playGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" style={{ stopColor: "#00D4AA" }} />
                                                    <stop offset="100%" style={{ stopColor: "#00A8CC" }} />
                                                </linearGradient>
                                            </defs>
                                            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" fill="url(#playGradient)" />
                                        </svg>
                                        <div className="text-left">
                                            <div className="text-xs">GET IT ON</div>
                                            <div className="text-sm font-semibold">Google Play</div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {/* Spacer to prevent overflow */}
                            <div className="min-h-0" />
                        </div>
                    </div>
                )}
            </div>
        </aside>
    );
}

export default SideAppDownloadBanner;
